import React from 'react';
import { TrendingUp, Calendar, Clock } from 'lucide-react';
import type { MasternodeWithStats } from '../../hooks/useMasternodes';
import { calculateROI, formatROI } from '../../utils/calculations/roi';

interface ROIWidgetProps {
  nodes: MasternodeWithStats[];
}

export default function ROIWidget({ nodes }: ROIWidgetProps) {
  const roi = calculateROI(nodes);

  return (
    <div className="bg-slate-800/50 rounded-lg md:rounded-xl p-4 md:p-6 border border-green-500/10">
      <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6">
        <TrendingUp className="h-4 w-4 md:h-5 md:w-5 text-green-500" />
        <h3 className="text-base md:text-lg font-semibold">Return on Investment</h3>
      </div>

      <div className="grid grid-cols-3 gap-3 md:gap-4">
        <div className="p-3 md:p-4 bg-slate-900/50 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Clock className="h-3 w-3 md:h-4 md:w-4 text-green-500" />
            <span className="text-xs md:text-sm text-gray-400">Daily</span>
          </div>
          <div className="text-base md:text-xl font-mono text-green-400">
            {formatROI(roi.daily)}
          </div>
        </div>

        <div className="p-3 md:p-4 bg-slate-900/50 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <Calendar className="h-3 w-3 md:h-4 md:w-4 text-green-500" />
            <span className="text-xs md:text-sm text-gray-400">Monthly</span>
          </div>
          <div className="text-base md:text-xl font-mono text-green-400">
            {formatROI(roi.monthly)}
          </div>
        </div>

        <div className="p-3 md:p-4 bg-slate-900/50 rounded-lg">
          <div className="flex items-center gap-2 mb-2">
            <TrendingUp className="h-3 w-3 md:h-4 md:w-4 text-green-500" />
            <span className="text-xs md:text-sm text-gray-400">Yearly</span>
          </div>
          <div className="text-base md:text-xl font-mono text-green-400">
            {formatROI(roi.yearly)}
          </div>
        </div>
      </div>

      <p className="mt-4 text-xs text-gray-500 leading-relaxed">
        These figures represent the estimated block reward yield earned by locking TWINS as masternode collateral.
        They do not reflect any return on the TWINS coin price, nor any investment in a company or product.
        Rewards are paid in TWINS at a fixed rate per block and may change as network conditions evolve.
      </p>
    </div>
  );
}